import { ListGroup,Image } from "react-bootstrap";


const ListeEquipe = ({ teams, onTeamClick }) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return (
    <ListGroup>
      {teams.equipe.map((team, index) => (
        <ListGroup.Item key={index} action onClick={() => onTeamClick(team)} style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <Image src={`${apiUrl}/image/equipe/${team.logo}`}  roundedCircle width="30" height="30" className="mr-2" />
          &nbsp;{team.nom}
        </ListGroup.Item>
      ))}
    </ListGroup>
  )};


export default ListeEquipe;